import { createXKey } from './utils';
import { ElementSelect } from './elementSelect';
export function ElementSelectByX(options) {
    return ElementSelect(Object.assign(Object.assign({}, options), { createGroup: createXKey }));
}
//# sourceMappingURL=elementSelectByX.js.map